var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "md-dialog",
    {
      attrs: {
        "md-active": _vm.active,
        "md-close-on-esc": false,
        "md-click-outside-to-close": false
      },
      on: {
        "update:mdActive": function($event) {
          _vm.active = $event
        },
        "update:md-active": function($event) {
          _vm.active = $event
        }
      }
    },
    [
      _c("md-dialog-title", [
        _vm._v(
          _vm._s(_vm.i18n.lbl_sub()) + " - " + _vm._s(_vm.values.Description)
        )
      ]),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_exchange_asset(), value: _vm.values.Asset }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_balance(), value: _vm.values.Balance }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_my_wallet(), value: _vm.values.WalletId }
      }),
      _vm._v(" "),
      _c("detail", {
        attrs: { prop: _vm.i18n.lbl_user(), value: _vm.values.UserId }
      }),
      _vm._v(" "),
      _c(
        "md-dialog-actions",
        [
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.close }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_cancel()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.deleteWallet }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_delete()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.transfetToWallet }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_sub_transfer()))]
          ),
          _vm._v(" "),
          _c(
            "md-button",
            {
              staticClass: "md-button btn md-primary md-theme-default",
              attrs: { disabled: _vm.isLoading },
              on: { click: _vm.setChange }
            },
            [_vm._v(_vm._s(_vm.i18n.lbl_sub_edit()))]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-86ba69f2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86ba69f2","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/vue/app/dashboard/index/DeleteSubwalletModal.vue
// module id = 4Pas
// module chunks = 1